export default __webpack_public_path__ + "static/media/0111.0f96ce71.png";